var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('check-defect-remark-detail',{attrs:{"article-check-point-id":_vm.articleCheckPointId,"remark-list":_vm.remarkList,"defect-list":_vm.defectList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }